module.exports = __webpack_public_path__ + "static/media/close.6417af3c.svg";